"use strict";

var _classCallCheck = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var contracts_1 = require("@abridged/contracts");

var AbstractContract_1 = require("./AbstractContract");

var TokenContract = /*#__PURE__*/function (_AbstractContract_1$A) {
  _inherits(TokenContract, _AbstractContract_1$A);

  var _super = _createSuper(TokenContract);

  function TokenContract(sdk) {
    var _this;

    _classCallCheck(this, TokenContract);

    _this = _super.call(this, sdk, contracts_1.ContractNames.ERC20Token);
    _this.sdk = sdk;
    return _this;
  }

  _createClass(TokenContract, [{
    key: "getName",
    value: function getName(token) {
      return this.methods.name().call({
        to: token
      }).then(function (_ref) {
        var result = _ref.result;
        return result;
      });
    }
  }, {
    key: "getSymbol",
    value: function getSymbol(token) {
      return this.methods.symbol().call({
        to: token
      }).then(function (_ref2) {
        var result = _ref2.result;
        return result;
      });
    }
  }, {
    key: "getDecimals",
    value: function getDecimals(token) {
      return this.methods.decimals().call({
        to: token
      }).then(function (_ref3) {
        var result = _ref3.result;
        return result;
      });
    }
  }, {
    key: "getTotalSupply",
    value: function getTotalSupply(token) {
      return this.methods.totalSupply().call({
        to: token
      }).then(function (_ref4) {
        var result = _ref4.result;
        return result;
      });
    }
  }, {
    key: "getBalanceOf",
    value: function getBalanceOf(token, owner) {
      return this.methods.balanceOf(owner).call({
        to: token
      }).then(function (_ref5) {
        var result = _ref5.result;
        return result;
      });
    }
  }, {
    key: "getAllowance",
    value: function getAllowance(token, owner, spender) {
      return this.methods.allowance(owner, spender).call({
        to: token
      }).then(function (_ref6) {
        var result = _ref6.result;
        return result;
      });
    }
  }, {
    key: "buildTransferData",
    value: function buildTransferData(options) {
      var to = options.to,
          value = options.value;
      return this.methods.transfer(to, value).data;
    }
  }, {
    key: "buildTransferFromData",
    value: function buildTransferFromData(options) {
      var from = options.from,
          to = options.to,
          value = options.value;
      return this.methods.transferFrom(from, to, value).data;
    }
  }, {
    key: "buildApproveData",
    value: function buildApproveData(options) {
      var spender = options.spender,
          value = options.value;
      return this.methods.approve(spender, value).data;
    }
  }]);

  return TokenContract;
}(AbstractContract_1.AbstractContract);

exports.TokenContract = TokenContract;